import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Course } from '../education/types';
import { useLanguage } from '@/contexts/LanguageContext';

interface BrowseCoursesModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  courses: Course[];
  onSelectCourse: (course: Course) => void;
}

export function BrowseCoursesModal({ open, onOpenChange, courses, onSelectCourse }: BrowseCoursesModalProps) {
  const { t } = useLanguage();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>{t('education.browseCourses')}</DialogTitle>
          <DialogDescription>{t('education.description')}</DialogDescription>
        </DialogHeader>
        <ScrollArea className="h-[60vh]">
          <div className="grid gap-4 md:grid-cols-2">
            {courses.length === 0 && (
              <div className="text-center text-muted-foreground py-8">{t('dashboard.instructor.dashboard.cards.courses.noData')}</div>
            )}
            {courses.map((course) => (
              <div key={course.id} className="border rounded-lg p-4 flex flex-col gap-2 bg-background">
                <div className="flex items-center gap-2">
                  <span className="font-semibold text-lg">{course.title}</span>
                  {course.certificate && (
                    <Badge className="bg-[#7dda55] text-white">{t('dashboard.instructor.dashboard.certificateAvailable')}</Badge>
                  )}
                </div>
                <div className="text-sm text-muted-foreground">{course.description}</div>
                <div className="flex items-center gap-2">
                  <Badge variant="secondary">{t(`dashboard.instructor.dashboard.categories.${course.category}`)}</Badge>
                  <span className="text-xs text-muted-foreground">{course.totalLessons} {t('dashboard.instructor.dashboard.lessons')}</span>
                </div>
                <Button className="mt-2 w-fit" onClick={() => onSelectCourse(course)}>
                  {t('education.startCourse')}
                </Button>
              </div>
            ))}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
} 